const LETTER_PATTERN = /\p{L}/u;
const ADDRESS_ALWAYS_UPPERCASE_TOKENS = new Set([
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "NT",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "USA",
  "YT",
]);
const ADDRESS_MIXED_ALPHANUMERIC_TOKEN_PATTERN = /\b(?=[\p{L}\p{N}]*\p{L})(?=[\p{L}\p{N}]*\p{N})[\p{L}\p{N}]+\b/gu;
const ADDRESS_SHORT_TOKEN_PATTERN = /\b\p{L}{2,3}\b/gu;
const ORDER_PRODUCT_CODE_KEYS = [
  "Code Produit",
  "Code de produit",
  "code_produit",
  "code_de_produit",
  "grain_code",
];
const ADDRESS_TITLE_CASE_BOUNDARY_PATTERN = /(^|[\s\-/'\u2019().,])(\p{L})/gu;
const TITLE_CASE_BOUNDARY_PATTERN = /(^|[\s\-/'\u2019().])(\p{L})/gu;

function normalizeDisplayText(value) {
  return typeof value === "string" ? value.trim() : "";
}

function shouldNormalizeMostlyUppercaseLabel(text) {
  const letters = Array.from(text).filter((character) => LETTER_PATTERN.test(character));
  if (!letters.length) {
    return false;
  }

  const uppercaseRatio = letters.filter((character) => character === character.toLocaleUpperCase("fr-CA")).length / letters.length;
  return uppercaseRatio >= 0.72;
}

function applyTitleCase(text, boundaryPattern = TITLE_CASE_BOUNDARY_PATTERN) {
  return text
    .toLocaleLowerCase("fr-CA")
    .replace(boundaryPattern, (match, prefix, letter) => `${prefix}${letter.toLocaleUpperCase("fr-CA")}`);
}

export function normalizeClientDisplayLabel(value) {
  const text = normalizeDisplayText(value);
  if (!text) {
    return "";
  }

  if (!shouldNormalizeMostlyUppercaseLabel(text)) {
    return text;
  }

  return applyTitleCase(text);
}

export function normalizeAddressDisplayLabel(value) {
  const text = normalizeDisplayText(value);
  if (!text) {
    return "";
  }

  if (!shouldNormalizeMostlyUppercaseLabel(text)) {
    return text;
  }

  const titleCasedText = applyTitleCase(text, ADDRESS_TITLE_CASE_BOUNDARY_PATTERN);
  const alphanumericRestoredText = titleCasedText.replace(
    ADDRESS_MIXED_ALPHANUMERIC_TOKEN_PATTERN,
    (token) => token.toLocaleUpperCase("fr-CA"),
  );

  return alphanumericRestoredText.replace(ADDRESS_SHORT_TOKEN_PATTERN, (token) => {
    const uppercasedToken = token.toLocaleUpperCase("fr-CA");
    return ADDRESS_ALWAYS_UPPERCASE_TOKENS.has(uppercasedToken) ? uppercasedToken : token;
  });
}

export function normalizeProductCodeDisplay(value) {
  const text = normalizeDisplayText(value);
  return text ? text.toLocaleLowerCase("fr-CA") : "";
}

export function resolveOrderProductCodeDisplay(order) {
  const directProductCode = normalizeProductCodeDisplay(order?.grain_code);
  if (directProductCode) {
    return directProductCode;
  }

  const rawData = order?.raw_data && typeof order.raw_data === "object" ? order.raw_data : null;
  if (!rawData) {
    return "";
  }

  for (const key of ORDER_PRODUCT_CODE_KEYS) {
    const candidate = normalizeProductCodeDisplay(rawData[key]);
    if (candidate) {
      return candidate;
    }
  }

  return "";
}